import { TipoDeRegraDePermissao } from '@/models/RegraDeNegocio'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDePainelDeIntegracao: RouteConfig[] = [
	{
		path: 'painel-de-integracao',
		name: 'Painel de Integração',
		components: {
			default: () => import('@/views/application/integracao/TelaDePainelDeIntegracao.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			regraDeNegocio: 'acesso-painel-de-integracao' as TipoDeRegraDePermissao,
		},
	},
]

export default rotasDePainelDeIntegracao
